import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOffSharp";
import { Button, Card, InputAdornment, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  validateOldPassword
} from "../../common/inputValidation";
import { MuiInput } from "../../components";
import { changePasswordAPI, logout } from "../../redux/authSlice";
import { useAppDispatch } from "../../store/hooks";
import { useDynamicForm } from "../../components/formBuilder/useDynamicForm";


const initialFValues = {
  OldPassword: "",
  NewPassword: "",
  ConfirmPassword: "",
};

export default function ChangePassword() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isOldPasswordVisible, setIsOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);

  const validate = (fieldValues = values) => {
    let temp: any = { ...errors };
    if ("OldPassword" in fieldValues)
      temp.OldPassword = fieldValues.OldPassword
        ? !validateOldPassword(fieldValues.OldPassword, 8)
          ? ""
          : ("Please enter a valid Old Password.")
        : "This field is required.";
    if ("NewPassword" in fieldValues)
      temp.NewPassword = fieldValues.NewPassword
        ? // ? !validateNewPassword(fieldValues.NewPassword, 8)
        ""
        : ("Please enter a valid New Password.");
    // : "This field is required.";
    if ("ConfirmPassword" in fieldValues)
      temp.ConfirmPassword = fieldValues.ConfirmPassword
        ? // ? !validateConfirmPassword(fieldValues.ConPassword, 8)
        ""
        : ("Please enter a valid Confirm Password.");
    // : "This field is required.";
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  const { values, setValues, errors, setErrors, resetForm, handleInputChange } =
    useDynamicForm(initialFValues, true, validate);

  const toggleOldPassword = (e: any) => {
    e.preventDefault();
    setIsOldPasswordVisible(!isOldPasswordVisible);
  };
  const toggleNewPassword = (e: any) => {
    e.preventDefault();
    setIsNewPasswordVisible(!isNewPasswordVisible);
  };
  const toggleConfirmPassword = (e: any) => {
    e.preventDefault();
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleChangePassword = async (e: any) => {
    e.preventDefault();

    if (validate()) {
      let request: any = {
        OldPassword: values.OldPassword,
        NewPassword: values.NewPassword,
        ConfirmPassword: values.ConfirmPassword,
      };
      let response: any = await dispatch(changePasswordAPI(request));
      if (response?.payload?.statusCode === 200 || response?.payload?.success) {
        dispatch(logout());
        navigate("/");
      }
    }
  };

  const onInputChange = (e: any) => {
    const { name, value } = e.target;
    setErrors({});

    if (name == "ConfirmPassword") {
      if (value !== values?.NewPassword) {
        setErrors({ ...errors, [name]: "incorrect password" });
      }
    }
    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <Card
      component={Stack}
      variant='outlined'
      sx={{
        margin: "100px auto",
        maxWidth: "400px",
        minWidth: "300px",
        padding: 4,
        borderRadius: 4,
        gap: 2,
      }}
    >
      <Typography variant="h2" align='center'>Change Password</Typography>
      <MuiInput
        fullWidth
        label={("Old Password")}
        name="OldPassword"
        placeholder="Enter old password"
        type={!isOldPasswordVisible ? "Password" : "text"}
        value={values.OldPassword}
        error={errors.OldPassword}
        onChange={onInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                toggleOldPassword(e);
              }}
            >
              {isOldPasswordVisible && <VisibilityIcon />}
              {!isOldPasswordVisible && <VisibilityOffIcon />}
            </InputAdornment>
          ),
        }}
      />

      <MuiInput
        fullWidth
        label={("New Password")}
        name="NewPassword"
        placeholder="Enter new password"
        type={!isNewPasswordVisible ? "Password" : "text"}
        value={values.NewPassword}
        onChange={onInputChange}
        error={errors.NewPassword}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                toggleNewPassword(e);
              }}
            >
              {isNewPasswordVisible && <VisibilityIcon />}
              {!isNewPasswordVisible && <VisibilityOffIcon />}
            </InputAdornment>
          ),
        }}
      />

      <MuiInput
        fullWidth
        label={("Confirm Password")}
        name="ConfirmPassword"
        placeholder="Enter confirm password"
        type={!isConfirmPasswordVisible ? "Password" : "text"}
        value={values.ConfirmPassword}
        onChange={onInputChange}
        error={errors.ConfirmPassword}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                toggleConfirmPassword(e);
              }}
            >
              {isConfirmPasswordVisible && <VisibilityIcon />}
              {!isConfirmPasswordVisible && <VisibilityOffIcon />}
            </InputAdornment>
          ),
        }}
      />

      <Button
        disabled={
          values.OldPassword &&
            values.NewPassword &&
            values.ConfirmPassword &&
            !errors?.OldPassword &&
            !errors?.NewPassword &&
            !errors?.ConfirmPassword
            ? false
            : true
        }
        variant="contained"
        children="Submit request"
        type="submit"
        onClick={handleChangePassword}
        size="medium"
      />
    </Card>
  );
}
